import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './Templates.css';

// Helper to pick a random image from an array
function getRandomImage(images) {
    return images[Math.floor(Math.random() * images.length)];
}

const templateTypePreviews = {
    'agent-templates': [
        require('../../assets/imgs/previews/agent/base.jpg'),
        require('../../assets/imgs/previews/agent/skyline.jpg'),
        require('../../assets/imgs/previews/agent/futuristic.jpg'),
    ],
    'brokerage-templates': [
        require('../../assets/imgs/previews/brokerage/base.jpg'),
        require('../../assets/imgs/previews/brokerage/luxury.jpg'),
        require('../../assets/imgs/previews/brokerage/metropolitan.jpg'),
        require('../../assets/imgs/previews/brokerage/vibrance.jpg'),
    ],
    'landing-pages': [
        require('../../assets/imgs/previews/landing/base.jpg'),
        require('../../assets/imgs/previews/landing/condo.jpg'),
        require('../../assets/imgs/previews/landing/townhouse.jpg'),
        require('../../assets/imgs/previews/landing/multiplex.jpg'),
    ],
    'newsletters': [
        require('../../assets/imgs/previews/newsletters/monthlyfeatured.jpg'),
        require('../../assets/imgs/previews/newsletters/interiordesign.jpg'),
        require('../../assets/imgs/previews/newsletters/buyersguide.jpg'),
        require('../../assets/imgs/previews/newsletters/springupdate.jpg'),
    ],
};

const templateTypeMobilePreviews = {
    'agent-templates': [
        require('../../assets/imgs/previews/mobile/agent/base.jpg'),
        require('../../assets/imgs/previews/mobile/agent/luxury.jpg'),
        require('../../assets/imgs/previews/mobile/agent/metropolitan.jpg'),
        require('../../assets/imgs/previews/mobile/agent/vibrance.jpg'),
    ],
    'brokerage-templates': [
        require('../../assets/imgs/previews/mobile/brokerage/base.jpg'),
        require('../../assets/imgs/previews/mobile/brokerage/skyline.jpg'),
        require('../../assets/imgs/previews/mobile/brokerage/futuristic.jpg'),
    ],
    'landing-pages': [
        require('../../assets/imgs/previews/mobile/landing/base.jpg'),
        require('../../assets/imgs/previews/mobile/landing/condo.jpg'),
        require('../../assets/imgs/previews/mobile/landing/townhouse.jpg'),
        require('../../assets/imgs/previews/mobile/landing/multiplex.jpg'),
    ],
    'newsletters': [
        require('../../assets/imgs/previews/mobile/newsletters/monthlyfeatured.jpg'),
        require('../../assets/imgs/previews/mobile/newsletters/interiordesign.jpg'),
        require('../../assets/imgs/previews/mobile/newsletters/buyersguide.jpg'),
        require('../../assets/imgs/previews/mobile/newsletters/springupdate.jpg'),
    ],
};

const phoneFrame = require('../../assets/imgs/mockups/phone-mockup-transparent.png');

const templateTypes = [
    {
        id: 'agent-templates',
        title: 'Agent',
        description: 'Modern, customizable websites for real estate agents. Clean layouts, beautiful galleries, and lead capture.',
    },
    {
        id: 'brokerage-templates',
        title: 'Brokerage',
        description: 'Professional multi-agent websites for brokerages. Team pages, listings, and branding options.',
    },
    {
        id: 'landing-pages',
        title: 'Landing Pages',
        description: 'High-converting landing pages for listings, events, or lead generation. Fast, focused, and effective.',
    },
    {
        id: 'newsletters',
        title: 'Newsletters',
        description: 'Beautiful, responsive newsletter templates to keep your clients engaged and informed.',
    },
];

const Templates = () => {
    // Pick a random image for each template type on each render
    const cards = templateTypes.map(type => ({
        ...type,
        img: getRandomImage(templateTypePreviews[type.id]),
        mobileImg: getRandomImage(templateTypeMobilePreviews[type.id])
    }));

    return (
        <>
            <Helmet>
                <title>Website Templates | AptoWebsites</title>
                <meta name="description" content="Browse modern, mobile-friendly real estate website templates for agents, brokerages, and landing pages. Preview and choose your design." />
                <meta name="keywords" content="real estate templates, agent website templates, brokerage website templates, landing page templates, AptoWebsites" />
                <meta property="og:title" content="Website Templates | AptoWebsites" />
                <meta property="og:description" content="Browse modern, mobile-friendly real estate website templates for agents, brokerages, and landing pages." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://aptowebsites.com/templates" />
                <meta property="og:image" content="https://aptowebsites.com/og-image.jpg" />
                <link rel="canonical" href="https://aptowebsites.com/templates" />
            </Helmet>
            <div className="templatebackground">
                <div className="templates-main-header">
                    <h1 className="templates-title">Choose Your Template Type</h1>
                    <p className="templates-subtitle">
                        Explore our professionally designed templates for every real estate need.
                    </p>
                </div>
                <div className="main-template-type-list">
                    {cards.map(type => (
                        <Link to={`/${type.id}`} key={type.id} className="template-type-card">
                            <div className="template-img-wrapper overlap">
                                <img src={type.img} alt={type.title} className="template-img main-img" />
                                <div className="phone-mockup-container overlap">
                                    <img
                                        src={phoneFrame}
                                        alt="Phone Mockup"
                                        className="phone-mockup-img"
                                    />
                                    <img
                                        src={type.mobileImg}
                                        alt={`${type.title} mobile`}
                                        className="main-template-img phone-inside-img"
                                    />
                                </div>
                            </div>
                            <div className="template-type-info">
                                <h2>{type.title}</h2>
                                <p>{type.description}</p>
                                <span className="template-type-link">View Templates &rarr;</span>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Templates;
